export default __webpack_public_path__ + "static/media/icon_logs.fa981c29.svg";